/**
 * @generated SignedSource<<4a9e699f531c079992497c8d35e02a49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DetachPaymentMethodInput = {
  id: string;
};
export type DeletePaymentMethodDialogMutation$variables = {
  input: DetachPaymentMethodInput;
};
export type DeletePaymentMethodDialogMutation$data = {
  readonly detachPaymentMethod: {
    readonly id: string;
  } | null | undefined;
};
export type DeletePaymentMethodDialogMutation = {
  response: DeletePaymentMethodDialogMutation$data;
  variables: DeletePaymentMethodDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePaymentMethodDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "detachPaymentMethod",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePaymentMethodDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "detachPaymentMethod",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "438ce49035291b1776c5a8449cce3f70",
    "id": null,
    "metadata": {},
    "name": "DeletePaymentMethodDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePaymentMethodDialogMutation(\n  $input: DetachPaymentMethodInput!\n) {\n  detachPaymentMethod(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c80796fef132cc505f53c8fe013abda";

export default node;
